import { Link } from "react-router-dom";
import { Button } from "../ui/button";
import { Shield, AlertTriangle, ArrowRight } from "lucide-react";
import Reveal from "./Reveal";

const KlartextCheckTeaser = () => {
  return (
    <section className="relative py-16 md:py-20 overflow-hidden bg-aurora">
      {/* Background decorations */}
      <div className="absolute inset-0 bg-circuit opacity-60 pointer-events-none" aria-hidden="true"></div>
      <div className="absolute top-10 left-10 w-40 h-40 bg-primary/10 rounded-full blur-3xl" aria-hidden="true"></div>
      <div className="absolute bottom-10 right-10 w-56 h-56 bg-accent/10 rounded-full blur-3xl" aria-hidden="true"></div>

      <div className="mx-auto w-full max-w-7xl px-6 relative z-10">
        <Reveal className="flex flex-col lg:flex-row items-center gap-8 lg:gap-16">
          {/* Left: Icon & Badge */}
          <div className="flex-shrink-0">
            <div className="relative">
              <div className="w-32 h-32 md:w-40 md:h-40 rounded-[2rem] bg-gradient-to-br from-navy to-primary flex items-center justify-center shadow-lift">
                <Shield className="h-16 w-16 md:h-20 md:w-20 text-white" />
              </div>
              <div className="absolute -top-2 -right-2 w-12 h-12 rounded-full bg-red-500 flex items-center justify-center shadow-lg ">
                <AlertTriangle className="h-6 w-6 text-white" />
              </div>
              {/* Leiterbahn-Punkt */}
              <span className="absolute -bottom-2 -left-2 h-4 w-4 rounded-full border-2 border-flame bg-background" aria-hidden="true" />
            </div>
          </div>

          {/* Center: Content */}
          <div className="flex-1 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 rounded-full bg-primary/10 border border-primary/20 px-4 py-2 text-sm font-bold text-primary mb-4">
              <span className="relative flex h-2 w-2">
                <span className="hidden"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-primary"></span>
              </span>
              NEU: Kostenloser Sicherheitscheck
            </div>

            <h2 className="text-3xl md:text-4xl font-extrabold text-navy mb-4">
              <span className="bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
                Klartext-Check
              </span>{" "}
              gegen Internet-Betrug
            </h2>

            <p className="text-lg md:text-xl text-muted-foreground mb-6 max-w-2xl">
              Verdächtige E-Mail oder SMS erhalten? Prüfen Sie in Sekunden, ob es sich um
              <strong className="text-navy"> Phishing oder Betrug</strong> handelt – kostenlos und anonym.
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start">
              <Link to="/klartext-check">
                <Button className="group rounded-full bg-gradient-to-r from-primary to-accent px-8 py-4 text-lg font-bold text-white shadow-soft hover:shadow-lift hover:-translate-y-0.5 transition-all">
                  <Shield className="mr-2 h-5 w-5" />
                  Jetzt testen
                  <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
                </Button>
              </Link>

              <span className="text-muted-foreground text-base">
                100% kostenlos • Keine Anmeldung nötig
              </span>
            </div>
          </div>

          {/* Right: Example pills */}
          <div className="hidden xl:flex flex-col gap-3">
            <div className="flex items-center gap-3 bg-card rounded-full px-5 py-3 shadow-soft border border-red-200">
              <div className="w-3.5 h-3.5 rounded-full bg-red-500"></div>
              <span className="text-navy font-medium">"Paket beim Zoll..."</span>
            </div>
            <div className="flex items-center gap-3 bg-card rounded-full px-5 py-3 shadow-soft border border-amber-200 translate-x-4">
              <div className="w-3.5 h-3.5 rounded-full bg-amber-500"></div>
              <span className="text-navy font-medium">"Konto gesperrt..."</span>
            </div>
            <div className="flex items-center gap-3 bg-card rounded-full px-5 py-3 shadow-soft border border-emerald-200">
              <div className="w-3.5 h-3.5 rounded-full bg-emerald-500"></div>
              <span className="text-navy font-medium">"Bestellung versandt"</span>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default KlartextCheckTeaser;
